import { IonLabel } from '@ionic/react';
import { ReactElement, useCallback } from 'react';
import { Team, useListTeamsQuery } from '../../api/graphql/generated';
import i18n from '../../i18n';
import { useBeaconRouter } from '../../route/route.hooks';
import { HBIonItemProps, IonItem } from '../ionic/IonItem';
import { ObjectList, RowRenderer } from '../object/object-list';

interface TeamListProps {
  onSelect?: (id: string) => void;
  showRole?: boolean;
  filterRow?: ({ item, index }: { item: Team; index: number }) => boolean;
}

const TeamList = (props: TeamListProps): ReactElement => {
  const { onSelect, filterRow } = props;

  const { builder } = useBeaconRouter();

  const rowRenderer = useCallback<RowRenderer<Team>>(
    ({ item: team }) => {
      let itemProps: HBIonItemProps = {};
      if (onSelect) {
        itemProps = {
          onClick: (e) => {
            e.preventDefault();
            onSelect(team.id);
          },
          href: '#',
        };
      } else {
        itemProps = {
          detail: true,
          routerLink: builder.getTeamRoute(team.id),
        };
      }
      return (
        <IonItem key={team.id} {...itemProps}>
          <IonLabel>
            <h2>{team.name}</h2>
            <p>{team.description}</p>
          </IonLabel>
        </IonItem>
      );
    },
    [onSelect, builder]
  );

  return (
    <ObjectList
      query={{
        useQuery: useListTeamsQuery,
        queryOptions: {
          fetchPolicy: 'cache-and-network',
        },
      }}
      filterRow={filterRow}
      noResults={i18n.t('common:team_no_teams_found')}
      rowRenderer={rowRenderer}
    />
  );
};

export { TeamList };
